<template>
  <div v-if="!!phaseData">
    <field-label :label="'Quais medicamentos utilizados previamente?'" required>
      <v-row>
        <v-col v-for="option in medicineOptions" :key="option.value" lg="4" cols="6">
          <v-checkbox
            class="mt-4"
            :label="option.text"
            v-model="phaseData.medicines.selected"
            :value="option.value"
            hide-details
          />
        </v-col>
        <v-col cols="12">
          <text-field
            label="Qual?"
            v-if="phaseData.medicines.selected.includes('other')"
            value="other"
            :required="phaseData.medicines.selected.includes('other')"
            v-model="phaseData.medicines.other"
          />
        </v-col>
      </v-row>
    </field-label>
    <radio-options
      :label="'O paciente já foi internado alguma vez?'"
      :options="defaultOptions"
      v-model="phaseData.hospitalization.value"
      :required="true"
      @input="phaseData.hospitalization.times = null"
    />
    <radio-options
      label="Quantas vezes?"
      class="ml-4"
      v-if="phaseData.hospitalization.value"
      :options="timesOptions"
      v-model="phaseData.hospitalization.times"
      :required="phaseData.hospitalization.value"
      row
    />

    <field-label class="mt-8" label="Anotações">
      <text-area :readonly="disabled" :max-length="2000" v-model="phaseData.notes" />
    </field-label>
  </div>
</template>
<script>
import FieldLabel from '@/components/FieldLabel.vue'
import TextArea from '@/components/TextArea.vue'
import BasePhase from './BasePhase.vue'

import RadioOptions from '@/components/RadioOptions.vue'
import TextField from '@/components/TextField.vue'

export default {
  components: { FieldLabel, TextArea, TextField, RadioOptions },
  extends: BasePhase,
  data() {
    return {
      timesOptions: [
        {
          text: '1 a 3 vezes',
          value: '1_to_3',
        },
        {
          text: 'Mais que 3 vezes',
          value: 'more_then_3',
        },
      ],
      defaultOptions: [
        {
          text: 'Sim',
          value: true,
        },
        {
          text: 'Não',
          value: false,
        },
      ],
      medicineOptions: [
        {
          text: 'Nenhum',
          value: 'none',
        },
        {
          text: 'Corticoide Tópico',
          value: 'corticoide_topico',
        },
        {
          text: 'Corticoide Injetável',
          value: 'corticoide_injetavel',
        },
        {
          text: 'Corticoide oral',
          value: 'corticoide_oral',
        },
        {
          text: 'Anti-histamínico',
          value: 'anti_histaminico',
        },
        {
          text: 'Metotrexato',
          value: 'metotrexato',
        },
        {
          text: 'Ciclosporina',
          value: 'ciclosporina',
        },
        {
          text: 'Azatioprina',
          value: 'azatioprina',
        },
        {
          text: 'Micofenolato',
          value: 'micofenolato',
        },
        {
          text: 'Dupilumabe',
          value: 'dupilumabe',
        },
        {
          text: 'Fototerapia',
          value: 'fototerapia',
        },
        {
          text: 'Upadacitinibe',
          value: 'upadacitinibe',
        },
        {
          text: 'Baricitinibe',
          value: 'baricitinibe',
        },
        {
          text: 'Outro',
          value: 'other',
        },
      ],
    }
  },
  methods: {
    getDefaultData() {
      const data = {
        medicines: {
          selected: [],
          other: null,
        },
        hospitalization: {
          value: null,
          times: null,
        },
        notes: null,
      }
      return data
    },
  },
}
</script>

<style scoped></style>
